import { defineField, defineType } from 'sanity'

import getPageInfo, { seoGroup } from '../../objects/pageInfo'
import { strongEmLink } from '../../../data/richText'

export default defineType({
  title: 'Replacement Eligibility',
  name: 'replacementEligibility',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      group: 'content',
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'array',
      of: strongEmLink,
      group: 'content',
    }),
    defineField({
      title: 'Replacement Declined',
      name: 'replacementDeclined',
      type: 'object',
      fields: [
        defineField({
          title: 'Declined Title',
          name: 'title',
          type: 'string',
        }),
        defineField({
          title: 'Declined Content',
          name: 'content',
          type: 'array',
          of: strongEmLink,
        }),
      ],
      group: 'content',
    }),
    defineField({
      title: 'Replacement Approved',
      name: 'replacementApproved',
      type: 'object',
      fields: [
        defineField({
          title: 'Approved Title',
          name: 'title',
          type: 'string',
        }),
        defineField({
          title: 'Approved Content',
          name: 'content',
          type: 'array',
          of: strongEmLink,
        }),
      ],
      group: 'content',
    }),
    getPageInfo({ path: 'replacementProgram', lockCanonical: false }),
  ],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare(selection) {
      const { title = 'New Page', description: subtitle = '' } =
        selection.pageInfo || {}
      return {
        title,
        subtitle,
      }
    },
  },
})